/** 案件で求める条件：予算方針 価格重視 */
export const RFP_REQUIRED_CONDITION_BUDGET_POLICY_CHEAP = {
    label: '価格重視',
    value: 1,
};
/** 案件で求める条件：予算方針 バランス重視 */
export const RFP_REQUIRED_CONDITION_BUDGET_POLICY_AVERAGE = {
    label: 'バランス重視',
    value: 2,
};
/** 案件で求める条件：予算方針 内容重視 */
export const RFP_REQUIRED_CONDITION_BUDGET_POLICY_QUALITY = {
    label: '内容重視',
    value: 3,
};
/** 案件で求める条件：予算方針の一覧 */
export const RFP_REQUIRED_CONDITION_BUDGET_POLICIES = [
    RFP_REQUIRED_CONDITION_BUDGET_POLICY_CHEAP,
    RFP_REQUIRED_CONDITION_BUDGET_POLICY_AVERAGE,
    RFP_REQUIRED_CONDITION_BUDGET_POLICY_QUALITY,
];
